import { JilabaKeyEnum } from "./JilabaKeyEnum";
declare var require: any;
const CryptoJS =require('crypto-js');

export class JilabaAesED {


public static Encrypt(data: string, key: JilabaKeyEnum): string {
    let encryptedBase64Key = btoa(key.toString())
    let parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
    let encryptedData = null;
    encryptedData = CryptoJS.AES.encrypt(data.trim(), parsedBase64Key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    return encryptedData.toString();
  }

  public static Decrypt(data: string, key: JilabaKeyEnum): string {
    let encryptedBase64Key = btoa(key.toString())
    let parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
    let encryptedCipherText = data.trim();
    let decryptedData = null;

    decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

   return decryptedData.toString(CryptoJS.enc.Utf8);
  //  return data.toString();

  }
}
